"use client";

import React from "react";
import { withRef, withVariants } from "@udecode/cn";
import { PlateElement } from "@udecode/plate-common";
import { cva } from "class-variance-authority";
import { listStyles } from "@/components/cms/ContentEditor/config/style.config";

const listVariants = cva("m-0 ps-6", {
	variants: {
		variant: {
			ul: listStyles.ul,
			ol: listStyles.ol,
		},
	},
});

const ListElementVariants = withVariants(PlateElement, listVariants, [
	"variant",
]);

// @ts-ignore
export const ListElement = withRef<typeof ListElementVariants>(
	({ className, children, variant = "ul", ...props }, ref) => {
		const Component = variant!;

		return (
			<ListElementVariants ref={ref} asChild {...props}>
				<Component>{children}</Component>
			</ListElementVariants>
		);
	}
);
